<template>
  <v-container class="feed-comp">
    <div v-for="postcard in postcards" :key="postcard.id" class="feed__postcard" :showPins="showPins">
      <div class="postcard-wrapper" :class="{ unApproved: !postcard.approved && !postcard.show }">
        <div v-if="!postcard.approved" class="unApproved_note" :class="{ 'd-none': postcard.show }">
          <span v-if="postcard.hidden">Diese Postkarte wurde von der Redaktion abgelehnt!</span>
          <span v-if="!postcard.hidden">Diese Postkarte ist noch nicht freigegeben!</span>
          <br />
          <span v-if="loggedInUser != null && loggedInUser.level_of_user !== 'normal'">
            Als "{{ loggedInUser.level_of_user }}" kannst du die Postkarte
            <a class="review" @click="showPostcard(postcard)">jetzt prüfen!</a>
          </span>
        </div>
        <PostCardMobile v-if="isMobile" :postcard_info="postcard" :loggedInUser="loggedInUser" class="postcard"
          :class="{ 'active-style_ButtonBar': postcard.approved }" />
        <PostCard v-else :postcard_info="postcard" :loggedInUser="loggedInUser" :showPins="showPins" class="postcard" />
        <PostcardBar v-if="postcard.approved" :id="postcard.id" ref="postcardBar" v-model="postcard.isSaved"
          class="button_row" :bookmarked="postcard.isSaved" :sender="postcard.sender" :topic="postcard.subject"
          :postcard="postcard" @showModal="openBookmarkModal" @answer="answerPostcard" />
        <PostcardAnswers v-if="postcard.answers?.length !== 0" :id="postcard.id" ref="postcardAnswers"
          :answers="postcard.answers" @showModal="openBookmarkModal"/>
        <!--        <div id="bookmarkModal" class="modal" @click="closeBookmarkModal($event)" style="display: none">
          <div class="modal-content">
            <span class="close" @click="closeBookmarkModal($event)"><v-icon>$x</v-icon></span>
            <p class="bookmark-modal-heading heading-three font-dark-grey">Postkarte speichern</p>
            <p class="bookmark-modal-text font-dark-grey font-medium">
              Du kannst Postkarten speichern, wenn du ein Konto angelegt hast. Möchtest du jetzt ein
              eigenes Profil erstellen?
            </p>
            <Button
              label_text="Profil erstellen"
              :is-primary="true"
              @click.native="
                $event.stopPropagation();
                $router.push('/register');
              "
            />
          </div>
        </div>-->
      </div>
      <!-- TODO here would be where the children have to be displayed
      which would basically be another for each but with the children of postcard
      so we should make this whole foreach block a reusable component with a prop "isChild"
       keywords for search: parent answer {{ postcard.children.length }}
      -->
    </div>
    <v-dialog v-model="modal.show" width="auto" class="feed--dialog">
      <v-card>
        <v-card-title style="text-align: center; margin: auto">{{ modal.title }}</v-card-title>
        <v-card-text> {{ modal.text }}</v-card-text>
        <v-card-actions><Button label_text="Profil erstellen" :is-primary="true" @click.native="
          $event.stopPropagation();
        $router.push('/register');
        " />
          <Button label_text="Login" :is-primary="true" @click.native="
            $event.stopPropagation();
          $router.push('/login');
          " /></v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-if="Answer.writeAnswer" v-model="Answer.writeAnswer" fullscreen class="answer-dialog">
      <div class="write-answer-dialog" >
        <PostCardMobile v-if="isMobile" :postcard_info="Answer.ParentPostcardInfo" :loggedInUser="loggedInUser"
          class="postcard answer-parent-postcard-mobile"/>
        <PostCard v-else :postcard_info="Answer.ParentPostcardInfo" :loggedInUser="loggedInUser"
          class="postcard answer-parent-postcard" />

        <PostCardMobile v-if="isMobile" ref="editPostcard"
          :postcard_info="Object.assign({ readOnly: false, topicFixed: true }, Answer.PostcardInfo)"
          class="content__postcard-mobile" @writtenTextChanged="updateText" @eventTitleChanged="updateEventTitle" @eventStartDateTimeChanged="updateEventStartDateTime" @eventEndDateTimeChanged="updateEventEndDateTime" />
        <PostCard v-else ref="editPostcard"
          :postcard_info="Object.assign({ readOnly: false, topicFixed: true }, Answer.PostcardInfo)"
          class="content__postcard" @writtenTextChanged="updateText" @eventTitleChanged="updateEventTitle" @eventStartDateTimeChanged="updateEventStartDateTime" @eventEndDateTimeChanged="updateEventEndDateTime" />
        <div class="answer-dialog__buttons">
          <div @click="closeModal">
          <Button label_text="Abbrechen" style="background-color: white" :is-primary="true" />
          </div>
          <Button
            label_text="Abschicken"
            :is-primary="true"
            :disabled="!Answer.PostcardInfo.text || Answer.PostcardInfo.text.trim().length === 0 ? 'disabled' : false"
            @click.native="$event.stopPropagation(); sendAnswer();"
          />
        </div>
      </div>
    </v-dialog>
    <div class="feed__end">
      <span v-if="isEndReached">
        Du hast alle Postkarten zu diesem Thema gelesen. Wenn du magst, kannst du selbst eine
        schreiben.
      </span>
      <span v-if="!isEndReached">
        Wenn du diesen Text liest, hat etwas mit dem Nachladen weiterer Postkarten nicht
        funktioniert. Versuche, ein Stück hochzuscrollen oder die Seite neuzuladen, um die
        restlichen Postkarten lesen zu können.
      </span>
    </div>
  </v-container>
</template>
<script>
import PostCard from "@/components/PostCard";
import PostCardMobile from "@/components/PostCardMobile";
import PostcardBar from "./PostcardBar";
import { getLoggedInUser } from "@/services/loggedIn";
import PostcardAnswers from "@/components/PostcardAnswers";
import Button from "@/components/Button";
import Api from "@/services/api";
import { useIsMobile } from "@/services/utils.js";


export default {
  name: "Feed",
  components: { Button, PostcardAnswers, PostcardBar, PostCard, PostCardMobile },
  setup() {
    const isMobile = useIsMobile();
    return { isMobile };
  },
  props: {
    postcards: { type: Array },
    showPins: {
      type: Boolean,
      default: true,
    },
    isEndReached: { type: Boolean },
  },
  data: () => ({
    modal: {
      show: false,
      title: "Du musst Angemeldet sein",
      text: "Du kannst diese Funktion Nutzen, wenn du ein Konto angelegt hast. Möchtest du jetzt ein eigenes Profil erstellen oder hast du bereits ein Profil?",
    },
    Answer: {
      ParentPostcardInfo: {},
      AnswerId: 0,
      writeAnswer: false,
      PostcardInfo: {
        text: "",
        attachments: [],
      },
    },
  }),
  watch: {
  "Answer.writeAnswer"(val) {
    document.body.classList.toggle("answer-dialog-open", val);
  },
},


  computed: {
    loggedInUser() {
      return JSON.parse(getLoggedInUser());
    }
  },
  methods: {
    answerPostcard(id) {
      if(!this.loggedInUser){
        this.$router.push('/login');
        return;
      }
      console.log(id);
      this.Answer.ParentPostcardInfo = this.postcards.find((e) => e.id === id);
      function getSender(user) {
        console.log(user);
        console.log(user.last_name.length, user.last_name.length <= 0);
        if (user.team && user.team.length > 0) {
          return user.team;
        } else if (user.last_name.length <= 0) {
          return user.first_name;
        } else {
          return user.first_name + " " + Array.from(user.last_name)[0] + ".";
        }
      }
      /*function getCurrentDate() {
        // this formats the datetime as it is returned by the database,
        // so it can be handled the same way by following methods
        // "2022-02-13 05:06:42"
        const date = new Date();
        const year = date.getFullYear();
        const month = ("0" + (date.getMonth() + 1)).slice(-2);
        const day = ("0" + date.getDate()).slice(-2);
        const hour = ("0" + date.getHours()).slice(-2);
        const minute = ("0" + date.getMinutes()).slice(-2);
        const second = ("0" + date.getSeconds()).slice(-2);
        return year + "-" + month + "-" + day + " " + hour + ":" + minute + ":" + second;
      }*/
      /* function detectMobile() {
        const toMatch = [
          /Android/i,
          /webOS/i,
          /iPhone/i,
          /iPad/i,
          /iPod/i,
          /BlackBerry/i,
          /Windows Phone/i,
        ];
        return toMatch.some((toMatchItem) => {
          return navigator.userAgent.match(toMatchItem);
        });
      } */

      this.Answer.PostcardInfo = {
        category: "Answer",
        text: "",
        attachments: [],
        sender: getSender(this.loggedInUser),
        sender_verified: this.loggedInUser.verified,
        topic: this.Answer.ParentPostcardInfo.allTopicNames?.find(
          (e) => e.name === this.Answer.ParentPostcardInfo.subject
        ) || null,
        subject: this.Answer.ParentPostcardInfo.subject,
        date: this.Answer.ParentPostcardInfo.date, //getCurrentDate(),
        sentFrom: this.isMobile ? "Phone" : "PC",
      };
      this.Answer.AnswerId = id;
      this.Answer.writeAnswer = true;
    },
    updateText(writtenText) {
      this.Answer.PostcardInfo.text = writtenText;
    },
    updateEventTitle(eventTitle) {
      this.Answer.PostcardInfo.eventTitle = eventTitle;
    },
    updateEventLocation(eventLocation) {
      this.Answer.PostcardInfo.eventLocation = eventLocation;
    },
    updateEventStartDateTime(eventStartDateTime) {
      this.Answer.PostcardInfo.eventStartDateTime = eventStartDateTime;
    },
    updateEventEndDateTime(eventEndDateTime) {
      this.Answer.PostcardInfo.eventEndDateTime = eventEndDateTime;
    },
    sendAnswer() {
      //console.log("editPostcard:", this.$refs.editPostcard);
      //console.log("attachments:", this.$refs.editPostcard.attachments);
      let Answer = {
        text: this.Answer.PostcardInfo.text,
        attachments: this.$refs.editPostcard.attachments,
        topic: { title: this.Answer.ParentPostcardInfo.subject },
        sendFrom: this.Answer.PostcardInfo.sentFrom,
        category: this.Answer.PostcardInfo.category,
        parent_post_id: this.Answer.ParentPostcardInfo.id
      };
      Api.postNewAnswer(Answer)
        .then((res) => {
          this.Answer.writeAnswer = false;
          document.body.classList.remove("answer-dialog-open");
          if (res.data) this.$router.push("/success");
        })
        .catch(/* there might be a 400 error if text or user are empty */);
    },
    closeModal() {
      this.Answer.writeAnswer = false;
      document.body.classList.remove("answer-dialog-open");
    },
    showPostcard(postcard) {
      if (postcard.approved) {
        postcard.show = true;
      } else if (this.loggedInUser.level_of_user !== "normal") {
        postcard.show = true;
        postcard.readOnly = false;
      }
    },

    hidePostcard(postcard) {
      postcard.show = false;
      postcard.readOnly = true;
    },

    openBookmarkModal(title) {
      this.modal.title = title;
      this.modal.show = true;
    },
    downloadPostcard(event, index) {
      this.$refs.postcardBar[index].downloadPostcard(event);
    },
    modalPostcardSaved(event, index) {
      this.$refs.postcardBar[index].savePostcard(event);
    },
  },
};
</script>
